import { useStore } from 'zustand';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ResultOption } from './result-option.component';

import {
  clearRecentSearches,
  userLocationStore,
} from '@/store/user-location.store';
import { AutocompletePrediction } from '@/types/google-maps.types';

export type RecentSearchedLocationsProps = {
  handleLocationClick: (item: AutocompletePrediction) => Promise<void>;
  callback: () => void;
};

export const RecentSearchedLocations = ({
  handleLocationClick,
  callback,
}: RecentSearchedLocationsProps) => {
  const recentSearches = useStore(
    userLocationStore,
    (state) => state.recentSearches,
  );

  const handleClearRecentSearches = () => {
    clearRecentSearches();
    callback();
  };

  return (
    <div
      className="flex flex-col gap-4 w-full"
      data-testid={DataTestIdEnum.LOCATION_RECENT_SEARCHED_RESULTS}
    >
      <div className="flex items-center justify-between">
        <p className="text-base leading-6 text-gray-700 font-semibold">
          Pesquisas recentes
        </p>
        <p
          data-testid={DataTestIdEnum.LOCATION_RECENT_SEARCHED_RESULTS_CLEAR}
          className="text-xs text-gray-500 items-center mt-1 cursor-pointer font-light hover:text-green-700"
          onClick={handleClearRecentSearches}
        >
          Limpar
        </p>
      </div>
      <div
        className="flex flex-col gap-5"
        data-testid={DataTestIdEnum.LOCATION_RECENT_SEARCHED_RESULTS_CONTAINER}
      >
        {recentSearches.map((recentSearch) => (
          <ResultOption
            key={`key-recent-search-${recentSearch.placeId}`}
            description={recentSearch.description}
            callback={async () => {
              await handleLocationClick(recentSearch);
            }}
          />
        ))}
      </div>
    </div>
  );
};
